import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { EspecieEppoPopupComponent } from '../../../core/components/popup/especies/especieEppoPopup.component';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcPais, Tc, WBotanicaExtendedViewModel, TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones, EnumIdsTcGrupo, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { ProductosExService } from './productosEx.service';
import { SolicitudProductosExViewModel, TProductoSolicitudExViewModel } from './productosEx.types';
import { HttpParams } from '@angular/common/http';
import { EnumIdsTwTcSubTipoSolicitudEx, EnumIdsTcEstadoSolicitudEx } from '../types/enum';
import { FormaViewModel } from '../../../_mantenimiento/especies/gruposformas/grupoforma.types';

@Component({
    selector: 'app-productosex-edit',
    templateUrl: './productosEx-edit.component.html',
})
export class ProductoExEditComponent extends ComponentBase implements OnInit {
    @ViewChild(EspecieEppoPopupComponent) private especieEppoPopupComponent: EspecieEppoPopupComponent;

    editMode = false;
    editTitle = 'Nuevo';
    codigoSolicitud: string;
    tituloTipoSolicitudEx: string;
    tituloEstadoSolicitudEx: string;
    tituloEstadoCertificadoFitoEx: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitudEx: number;
    IdTipoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    IdSubTipoSolicitudEx: number | null;
    IdSubTipoSolicitudExDescripcion: string;
    campoObligatorio = true;
    campoBultosObligatorio = false;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    listPais: Tc[];
    listProvincia: Tc[];
    listGrupo: Tc[];
    listForma: FormaViewModel[];
    listBulto: Tc[];
    provinciaObligatoria = false;

    //infoPaisPartidaPredua: string = "";
    IdPaisOrigen: number;
    IdEspecie: number;
    IdForma = 0;
    IdGrupo = 0;

    IdSolicitudEx: number;
    IdGrabador: number | null = null;

    solicitudProductosEx: SolicitudProductosExViewModel;
    productoEx: TProductoSolicitudExViewModel;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarBusquedaEppo = false;
    visibilitySpinner = false;
    esClonada = false;
    eppoObligatorio = true;
    laHeGrabadoYo = false;

    isCollapsedDatosBasicos = false;
    isCollapsedBulto = false;

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private productoExService: ProductosExService,
        private _location: Location,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudProductosEx = new SolicitudProductosExViewModel();
        this.productoEx = new TProductoSolicitudExViewModel();
    }

    ngOnInit() {
        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });
        this.globalService.getTipoBultos().subscribe(res => {
            this.listBulto = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];
        let idprod = +this.activatedRoute.snapshot.params['idprod'];

        this.IdSolicitudEx = id;
        //Para que se abran las pestañas de la solicitud
        this.guardRefreshPage(id);

        //EDIT DE PRODUCTO
        if (idprod) {
            this.editMode = true;
            this.editTitle = 'Editar';

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', id.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());

            this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.productoExService.getProductoEx(idprod).subscribe(result => {
                    this.productoEx = result;

                    this.globalService.getFormasByGrupo(this.productoEx.IdGrupo || 0).subscribe(res => {
                        this.listForma = res;
                    });
                    this.IdEstadoSolicitudEx = this.productoEx.IdEstadoSolicitudEx;
                    this.IdEstadoCertificadoFitoEx = this.productoEx.IdEstadoCertificadoFitoEx;
                    this.codigoSolicitud = this.productoEx.Codigo;
                    this.tituloTipoSolicitudEx = this.productoEx.IdTipoSolicitudExDescripcion;
                    this.IdTipoSolicitudEx = this.productoEx.IdTipoSolicitudEx;
                    this.tituloEstadoCertificadoFitoEx = this.productoEx.IdEstadoCertificadoFitoExDescripcion;
                    this.codigoTipoSolicitud = this.productoEx.CodigoTipoSolicitud;
                    this.IdResultadoEnvioMuestrasLaboratorioEx = this.productoEx.IdResultadoEnvioMuestrasLaboratorioEx;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.productoEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                    this.IdSubTipoSolicitudEx = this.productoEx.IdSubTipoSolicitudEx;
                    this.IdSubTipoSolicitudExDescripcion = this.productoEx.IdSubTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.productoEx.TwSolicitudJerarquiaEx != null &&
                        this.productoEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.IdForma = this.productoEx.IdForma;

                    this.updateForm();

                    //Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.productoEx.IdEstadoSolicitudEx, undefined)
                                .Visible && this.laHeGrabadoYo;
                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.productoEx.IdEstadoSolicitudEx, undefined)
                                .Visible && this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                            this.productoEx.IdEstadoSolicitudEx,
                            undefined,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION,
                            this.productoEx.IdEstadoSolicitudEx,
                            undefined,
                        ).Visible;
                    }

                    //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.productoEx.IdEstadoSolicitudEx, undefined).Visible;
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES_EXPORTACION, this.productoEx.IdEstadoSolicitudEx, undefined).Visible;

                    this.habilitarBusquedaEppo = this.IdForma > 0 ? this.habilitarEdicion : false;

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();
                    }

                    //SI ES PREVIA
                    if (this.productoEx.EsPrevia) {
                        if (
                            this.productoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.productoEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitudEx += '-Previa';
                        }
                        //Si es PREVIA SIN CODIGO se eliminan validaciones
                        if (this.productoEx.Codigo == null) {
                            this.RemoveValidationsPrevia();
                            this.campoObligatorio = false;
                        }
                    }
                });
            });
        } //FIN EDIT PRODUCTO

        //ALTA DE PRODUCTO
        else {
            this.productoExService.getSolicitudProductosEx(id).subscribe(result => {
                this.solicitudProductosEx = result;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_EMBALAJES,
                    this.solicitudProductosEx.IdEstadoSolicitudEx,
                    undefined,
                ).Visible;
                if (!this.habilitarGuardar) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                }

                this.IdEstadoSolicitudEx = this.solicitudProductosEx.IdEstadoSolicitudEx;
                this.IdEstadoCertificadoFitoEx = this.solicitudProductosEx.IdEstadoCertificadoFitoEx;
                this.codigoSolicitud = this.solicitudProductosEx.CodigoSolicitud;
                this.tituloTipoSolicitudEx = this.solicitudProductosEx.IdTipoSolicitudExDescripcion;
                this.IdTipoSolicitudEx = this.solicitudProductosEx.IdTipoSolicitudEx;

                this.tituloEstadoSolicitudEx = this.solicitudProductosEx.IdEstadoSolicitudExDescripcion;
                this.tituloEstadoCertificadoFitoEx = this.solicitudProductosEx.IdEstadoCertificadoFitoExDescripcion;
                this.codigoTipoSolicitud = this.solicitudProductosEx.CodigoTipoSolicitud;
                this.IdResultadoEnvioMuestrasLaboratorioEx = this.solicitudProductosEx.IdResultadoEnvioMuestrasLaboratorioEx;
                this.DescripcionIdResultadoEnvioMuestrasLaboratorioEx = this.solicitudProductosEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx;
                this.IdSubTipoSolicitudEx = this.solicitudProductosEx.IdSubTipoSolicitudEx;
                this.IdSubTipoSolicitudExDescripcion = this.solicitudProductosEx.IdSubTipoSolicitudExDescripcion;

                //this.esClonada = this.solicitudProductosEx.TwSolicitudJerarquia != null && this.solicitudProductosEx.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION ? true : false;

                //precargo el Pais de Origen de la solicitud
                if (this.solicitudProductosEx.IdPais != null) {
                    this.form.patchValue({
                        IdPais: this.solicitudProductosEx.IdPais,
                    });
                }
                this.onSelectPais();

                //SI ES PREVIA
                if (this.solicitudProductosEx.EsPrevia) {
                    if (
                        this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                        this.solicitudProductosEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitudEx += '-Previa';
                    }
                    //Si es PREVIA SIN CODIGO se eliminan validaciones
                    if (this.solicitudProductosEx.CodigoSolicitud == null) {
                        this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                }
            });
        } //FIN DE ALTA DE PRODUCTO

        //Contenedores
        this.isCollapsedDatosBasicos = false;
        this.isCollapsedBulto = false;
    }

    guardRefreshPage(id: number): void {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    private RemoveValidationsPrevia(): void {
        //this.removeValidators("NumeroDeclaracionSumaria");
    }

    private DisableControlsConsulta(): void {
        this.form.controls['IdGrupo'].disable();
        this.form.controls['IdForma'].disable();
        this.form.controls['CodigoTaric'].disable();
        this.form.controls['CodigoEppo'].disable();
        this.form.controls['NombreBotanico'].disable();
        this.form.controls['NombreComun'].disable();
        this.form.controls['IdPais'].disable();
        this.form.controls['IdProvincia'].disable();
        this.form.controls['Peso'].disable();
        this.form.controls['Volumen'].disable();
        this.form.controls['Unidades'].disable();
        this.form.controls['MarcasBulto'].disable();
        this.form.controls['NumeroBulto'].disable();
        this.form.controls['IdTipoBulto'].disable();
        this.form.controls['Nrc'].disable();
    }

    createForm(): void {
        this.form = this.fb.group({
            IdPais: [null, Validators.required],
            IdProvincia: null,
            IdGrupo: [null, Validators.required],
            IdForma: [null, Validators.required],
            CodigoTaric: [null, Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10)])],
            //Partida: [null, Validators.compose([Validators.required, Validators.maxLength(3), Validators.pattern("^[0-9]+([.,][0-9]+)?$")])],
            CodigoEppo: [null, Validators.required],
            NombreBotanico: [null, Validators.required],
            NombreComun: [null, Validators.required],
            Peso: [0, Validators.compose([Validators.required, CustomValidator.DecimalTopCero, CustomValidator.PesoFormatoValido])],
            Volumen: null,
            Unidades: null,
            Nrc: '',
            MarcasBulto: '',
            NumeroBulto: null,
            IdTipoBulto: null,
        });
    }

    updateForm(): void {
        this.form.setValue({
            IdPais: this.productoEx.IdPais,
            IdProvincia: this.productoEx.IdProvincia,
            IdGrupo: this.productoEx.IdGrupo,
            IdForma: this.productoEx.IdForma,
            CodigoTaric: this.productoEx.CodigoTaric,
            //Partida: this.producto.Partida,
            CodigoEppo: this.productoEx.CodigoEppo,
            NombreBotanico: this.productoEx.IdBotanicaDescripcion,
            NombreComun: this.productoEx.NombreComun,
            Peso: this.decimalPipe.transform(this.productoEx.Peso, '1.3-5', 'es'),
            Volumen: this.decimalPipe.transform(this.productoEx.Volumen, '1.3-3', 'es'),
            Unidades: this.productoEx.Unidades,
            MarcasBulto: this.productoEx.MarcasBulto,
            NumeroBulto: this.productoEx.NumeroBulto,
            IdTipoBulto: this.productoEx.IdTipoBulto,
            Nrc: this.productoEx.Nrc,
        });
        this.IdEspecie = this.productoEx.IdEspecie;

        if (this.productoEx.EspecieSinEppo) {
            this.removeValidators('CodigoEppo');
            this.eppoObligatorio = false;
        } else {
            this.addValidator('CodigoEppo', Validators.required);
            this.eppoObligatorio = true;
        }

        const idPais = this.form.value.IdPais;
        //Si es ESPAÑA
        if (idPais == EnumIdsTcPais.ID_ESPANA) {
            this.globalService.getProvincias().subscribe(res => {
                this.listProvincia = res;
            });
            this.addValidator('IdProvincia', Validators.required);
            this.provinciaObligatoria = true;
            this.form.controls['IdProvincia'].enable();
            this.form.patchValue({
                IdProvincia: this.productoEx.IdProvincia,
            });
        } else {
            this.listProvincia = [];
            this.removeValidators('IdProvincia');
            this.provinciaObligatoria = false;
            this.form.controls['IdProvincia'].disable();
        }

        //BULTOS
        if (this.form.value.IdTipoBulto != null && this.form.value.IdTipoBulto != 0) {
            this.campoBultosObligatorio = true;
            this.addValidator('IdTipoBulto', Validators.required);
            this.addValidator('NumeroBulto', Validators.required);
            this.addValidator('MarcasBulto', Validators.required);
        } else {
            this.campoBultosObligatorio = false;
            this.removeValidators('IdTipoBulto');
            this.removeValidators('NumeroBulto');
            this.removeValidators('MarcasBulto');
        }
    }

    saveProducto(): void {
        this.visibilitySpinner = true;
        this.onSubmit();
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.visibilitySpinner = false;
            this.addErrorMessage('Revise los datos del producto');

            this.isCollapsedDatosBasicos = false;
            this.isCollapsedBulto = false;

            return;
        }

        let pesoFormat = this.form.value.Peso.replace('.', '').replace(',', '.');
        let volumenFormat = this.form.value.Volumen != null ? this.form.value.Volumen.replace('.', '').replace(',', '.') : this.form.value.Volumen;

        let productoEx = new TProductoSolicitudExViewModel();

        //producto.Partida = this.form.value.Partida;
        productoEx.CodigoTaric = this.form.value.CodigoTaric;
        //producto.CodigoEppo = this.form.value.CodigoEppo; **hay q obtener el 'IdEspecie'
        productoEx.IdEspecie = this.IdEspecie;

        //producto.IdBotanicaDescripcion = this.form.value.NombreBotanico;
        productoEx.NombreComun = this.form.value.NombreComun;
        productoEx.IdPais = this.form.value.IdPais != null ? this.form.value.IdPais : this.IdPaisOrigen;
        productoEx.IdProvincia = this.form.value.IdProvincia;
        productoEx.MarcasBulto = this.form.value.MarcasBulto;
        productoEx.NumeroBulto = this.form.value.NumeroBulto;
        productoEx.IdTipoBulto = this.form.value.IdTipoBulto;
        productoEx.Peso = pesoFormat;
        productoEx.Volumen = volumenFormat;
        productoEx.Unidades = this.form.value.Unidades;

        productoEx.IdSolicitudEx = this.IdSolicitudEx;
        productoEx.Id = this.productoEx.Id;

        if (this.editMode) {
            this.productoExService.editProductoEx(productoEx).subscribe({
                next: res => {
                    this.addSuccessMessage('Producto modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                    this.isCollapsedBulto = false;
                },
            });
        } else {
            this.productoExService.createProductoEx(productoEx).subscribe({
                next: res => {
                    this.addSuccessMessage('Producto creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedDatosBasicos = false;
                    this.isCollapsedBulto = false;
                },
            });
        }
    }

    onAcceptDialogEspecieEppo(especieEppo: WBotanicaExtendedViewModel): void {
        //this.infoPaisPartidaPredua = partidaPredua.PaisOrigen;
        this.form.patchValue({
            CodigoEppo: especieEppo.CodigoEppo,
            NombreBotanico: especieEppo.IdNombreCientificoDescripcion,
            NombreComun: especieEppo.NombreComun,
        });

        this.IdEspecie = especieEppo.Id;
        //this.removeValidators("PaisPredua");
    }

    onSelectTipoBulto(): void {
        if (this.form.value.IdTipoBulto != null && this.form.value.IdTipoBulto != 0) {
            this.campoBultosObligatorio = true;
            this.addValidator('IdTipoBulto', Validators.required);
            this.addValidator('NumeroBulto', Validators.required);
            this.addValidator('MarcasBulto', Validators.required);
        } else {
            this.campoBultosObligatorio = false;
            this.removeValidators('IdTipoBulto');
            this.removeValidators('NumeroBulto');
            this.removeValidators('MarcasBulto');
        }
    }

    onChangeNumeroBulto(): void {
        if (this.form.value.NumeroBulto != '' && this.form.value.NumeroBulto != 0) {
            this.campoBultosObligatorio = true;
            this.addValidator('IdTipoBulto', Validators.required);
            this.addValidator('NumeroBulto', Validators.required);
            this.addValidator('MarcasBulto', Validators.required);
        } else {
            this.campoBultosObligatorio = false;
            this.removeValidators('IdTipoBulto');
            this.removeValidators('NumeroBulto');
            this.removeValidators('MarcasBulto');
        }
    }

    onChangeMarcasBulto(): void {
        if (this.form.value.MarcasBulto != '') {
            this.campoBultosObligatorio = true;
            this.addValidator('IdTipoBulto', Validators.required);
            this.addValidator('NumeroBulto', Validators.required);
            this.addValidator('MarcasBulto', Validators.required);
        } else {
            this.campoBultosObligatorio = false;
            this.removeValidators('IdTipoBulto');
            this.removeValidators('NumeroBulto');
            this.removeValidators('MarcasBulto');
        }
    }

    onSelectPais(): void {
        const idPais = this.form.value.IdPais;

        //Si es ESPAÑA
        if (idPais == EnumIdsTcPais.ID_ESPANA) {
            this.globalService.getProvincias().subscribe(res => {
                this.listProvincia = res;
            });
            this.addValidator('IdProvincia', Validators.required);
            this.provinciaObligatoria = true;
            this.form.controls['IdProvincia'].enable();
        } else {
            this.listProvincia = [];
            this.removeValidators('IdProvincia');
            this.provinciaObligatoria = false;
            this.form.controls['IdProvincia'].disable();
        }

        this.form.patchValue({
            IdProvincia: null,
        });
    }

    onSelectGrupo(): void {
        const idGrupo = this.form.value.IdGrupo || 0;

        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });

        this.form.patchValue({
            IdForma: null,
        });
    }

    onSelectForma(): void {
        this.IdForma = this.form.value.IdForma;

        let formaSeleccionada = this.listForma?.find(x => x.Id == this.IdForma);

        if (formaSeleccionada != null) {
            if ((<FormaViewModel>formaSeleccionada).EspecieSinEppo) {
                this.removeValidators('CodigoEppo');
                this.eppoObligatorio = false;
            } else {
                this.addValidator('CodigoEppo', Validators.required);
                this.eppoObligatorio = true;
            }
        }

        if (this.IdForma == null) {
            this.habilitarBusquedaEppo = false;
        } else {
            this.habilitarBusquedaEppo = true;
        }

        this.form.patchValue({
            CodigoEppo: '',
            NombreBotanico: '',
            NombreComun: '',
        });
    }

    onSearchCodigoEppo(): void {
        this.especieEppoPopupComponent.showDialog(this.form.controls['IdGrupo'].value, this.IdForma, null, false);
    }

    onBack(): void {
        //this.router.navigate(["/importacion/solicitud/productos", this.IdSolicitud])
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        this._location.back();
    }
}
